import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function NoNewMessages(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "NoNewMessages", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24.2931 12.5252c-.634 0-1.1479-.5095-1.1479-1.138V8.13804c0-.6285.5139-1.13804 1.1479-1.13804.634 0 1.148.50954 1.148 1.13804v3.24916c0 .6285-.514 1.138-1.148 1.138Zm-12.0157 5.0036c-.4483.4444-1.1751.4444-1.6234 0l-2.31778-2.2977c-.44829-.4445-.44829-1.1649 0-1.6094.4483-.4444 1.17516-.4444 1.62346 0l2.31772 2.2976c.4484.4445.4484 1.165 0 1.6095Zm24.0314 0c.4483.4444 1.1751.4444 1.6234 0l2.3178-2.2977c.4483-.4445.4483-1.1649 0-1.6094-.4483-.4444-1.1752-.4444-1.6235 0l-2.3177 2.2976c-.4483.4445-.4483 1.165 0 1.6095Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M44 24v14c0 1-1 2-2 2H6c-1 0-2-1-2-2V24c0-1 1-2 2-2h9c.8 0 1.4.4 1.8 1l2.4 5h9.6l2.4-5c.4-.6 1-1 1.8-1h9c1 0 2 1 2 2Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
NoNewMessages.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "NoNewMessages"
};
validateTidalLicense();
export {
  NoNewMessages
};
//# sourceMappingURL=NoNewMessages.js.map
